module.exports = __webpack_public_path__ + "img/pageinteriors_profesionales-independientes-y-pymes-03vida.1667c0e6.jpg";